export default "__VITE_PUBLIC_ASSET__8a332a8e__"